module.exports = __webpack_public_path__ + "img/05.46012b3d.jpg";